import { normalizeRoute } from '@/tools/utils/utils';
import {
  ESportsApiV1,
  ESportsRoutes,
  ESportsRoutesEN,
} from '../models/sports.model';
import { ELanguage } from './language';

export const toCamelCaseKeys = (
  obj: Record<string, any>
): Record<string, any> => {
  const toCamelCase = (key: string): string =>
    key
      .replace(/^[A-Z]/, (char) => char.toLowerCase())
      .replace(/_([a-z])/g, (_, char) => char.toUpperCase());

  const convert = (input: any): any => {
    if (Array.isArray(input)) {
      // If it is an array, apply the conversion to each element
      return input.map((item) =>
        typeof item === 'object' ? convert(item) : item
      );
    } else if (input !== null && typeof input === 'object') {
      // If it is an object, convert its keys and values recursively
      return Object.entries(input).reduce((acc, [key, value]) => {
        const camelCaseKey = toCamelCase(key);
        acc[camelCaseKey] = convert(value);
        return acc;
      }, {} as Record<string, any>);
    }
    // If it is neither an object nor an array, return the value as it is.
    return input;
  };

  return convert(obj);
};

export function normalizeEAllSports(input: string): ESportsApiV1 {
  const normalized = input.trim().toLowerCase();

  const match = Object.entries(ESportsApiV1).find(
    ([key, value]) =>
      value.toLowerCase() === normalized ||
      ESportsRoutes[key as keyof typeof ESportsRoutes]?.toLowerCase() ===
        normalized ||
      ESportsRoutesEN[key as keyof typeof ESportsRoutesEN]?.toLowerCase() ===
        normalized
  );

  if (!match) {
    throw new Error(`Valor inválido para deporte: ${input}`);
  }

  return match[1] as ESportsApiV1;
}

export function getSportRouteByLanguage(
  lang: ELanguage,
  sport: ESportsApiV1
): string {
  const apiKey = Object.entries(ESportsApiV1).find(
    ([_, value]) => value === sport
  )?.[0];

  if (!apiKey) {
    throw new Error(`Valor inválido para ESportsApiV1: ${sport}`);
  }

  if (lang === ELanguage.ES) {
    return normalizeRoute(ESportsRoutes[apiKey as keyof typeof ESportsRoutes]);
  }

  return normalizeRoute(
    ESportsRoutesEN[apiKey as keyof typeof ESportsRoutesEN]
  );
}
